<p *ngIf="data.message">
  <ngb-alert [type]="data.messageType" [dismissible]="false">
    {{ data.message }}
  </ngb-alert>
</p>
